import { render, staticRenderFns } from "./DailyPermitDetail.vue?vue&type=template&id=1f07c040&scoped=true"
import script from "./DailyPermitDetail.vue?vue&type=script&lang=js"
export * from "./DailyPermitDetail.vue?vue&type=script&lang=js"
import style0 from "./DailyPermitDetail.vue?vue&type=style&index=0&id=1f07c040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f07c040",
  null
  
)

export default component.exports